export const heroImage =
  'https://cdn.magicpatterns.com/uploads/osWKVxEn7pUZBNYvxmdK7r/a32bf61a-686e-4637-911e-3be6f0470690-Photoroom.webp'

/** Payment link used by every checkout button (the hero button scrolls to the offer instead). */
export const checkoutUrl = 'https://handball-360-ready.impultienda.ar/checkout'
export const brandName = 'HANDBALL 360 READY™'
export const price = '$27'
export const regularPrice = '$97'

/** Sent with every InitiateCheckout event. */
export const checkoutPixelParams = {
  content_name: 'Handball 360 Ready',
  value: 27,
  currency: 'USD',
}

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Visual coaching volumes' },
  { value: '72', label: 'Ready-to-run sessions' },
  { value: '5', label: 'Practical bonuses' },
]

export const heroBadges: string[] = [
  '100% in English',
  'Instant access',
  'Downloadable PDF',
  '7-day guarantee',
]

export interface Testimonial {
  quote: string
  role: string
  country: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I planned tonight’s session in minutes. Clear, visual, and incredibly easy to use.',
    role: 'Club Coach',
    country: 'United States',
  },
  {
    quote:
      'The progressions finally give my sessions a clear structure from warm-up to game.',
    role: 'Youth Coach',
    country: 'United Kingdom',
  },
  {
    quote:
      'I stopped searching for random drills. Now I open the session and start coaching.',
    role: 'Handball Coach',
    country: 'Australia',
  },
]

/** The 6:00 PM scene in the problem section. */
export const arrivalLines: string[] = [
  'Your players are arriving.',
  'Different levels.',
  'Different needs.',
  'Limited court space.',
  'Limited preparation time.',
]

export const sessionLines: string[] = [
  'One drill is too easy.',
  'Another is too difficult.',
  'Players wait in lines.',
  'There is no clear progression.',
  'You see mistakes but improvise the correction.',
]

/** The real cost of not having the right system. */
export type CostIcon = 'clock' | 'repeat' | 'route' | 'alert' | 'users' | 'eye'

export interface Cost {
  title: string
  detail: string[]
  icon: CostIcon
}

export const costs: Cost[] = [
  {
    icon: 'clock',
    title: 'Hours of planning',
    detail: ['Your free time is gone before practice starts.'],
  },
  {
    icon: 'repeat',
    title: 'Same drills, every week',
    detail: ['Players stop progressing.'],
  },
  {
    icon: 'route',
    title: 'No real progression',
    detail: ['Just drills, not a coaching pathway.'],
  },
  {
    icon: 'alert',
    title: 'Improvised corrections',
    detail: ['You see the error, but not the next step.'],
  },
  {
    icon: 'users',
    title: 'Mixed-level chaos',
    detail: ['Some get bored. Others get lost.'],
  },
  {
    icon: 'eye',
    title: 'Too much talking',
    detail: ['Players need to see it, not hear it.'],
  },
]

export const finalCost = {
  title: 'Every session starts from zero',
  lead: 'And the same question again:',
  question: '“What am I going to coach today?”',
}

/** Offer: what the access includes, shown above the price button. */
export const included: string[] = [
  'Step-by-step technique',
  'Illustrated drills',
  'Court diagrams',
  'Visual progressions',
  'Errors + quick fixes',
  'READY 60™ sessions',
  'Printable coaching tools',
  'Instant PDF download',
]

/** Closing: keep improvising vs. use the system. */
export const keepImprovising: string[] = [
  'Spend hours searching YouTube',
  'Save random drills from different sources',
  'Repeat the same exercises',
  'Build every session from zero',
  'Explain everything from memory',
  'Struggle with mixed-level groups',
  'Arrive at practice still thinking about the plan',
]

export const useTheSystem: string[] = [
  'Plan your session in minutes',
  'Open a complete READY 60™ session',
  'Follow a clear progression',
  'Use visual setups',
  'Use short coaching cues',
  'Adapt exercises to your group',
  'Move from technique to game',
  'Arrive ready to coach',
]

export interface ComparisonRow {
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    without: 'Hours searching for drills',
    with: '5 minutes to organize your session',
  },
  {
    without: 'No clear technical progression',
    with: '72 complete sessions ready to use',
  },
  {
    without: 'Players waiting in lines',
    with: 'Clear step-by-step progressions',
  },
  { without: 'Mixed-level chaos', with: 'Visual coaching system' },
  {
    without: 'Too much explanation',
    with: 'Adaptations for different levels',
  },
  { without: 'Random weekly planning', with: 'Practical coaching cues' },
  {
    without: 'Every training session starts from zero',
    with: 'A repeatable structure for every training week',
  },
]
